import React from 'react';

const Star = ({ fill }: { fill: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M7.1243 2.06901C7.76861 0.327775 10.2314 0.327775 10.8757 2.06901L11.9219 4.89643C12.1245 5.44387 12.5561 5.87549 13.1036 6.07806L15.931 7.1243C17.6722 7.76861 17.6722 10.2314 15.931 10.8757L13.1036 11.9219C12.5561 12.1245 12.1245 12.5561 11.9219 13.1036L10.8757 15.931C10.2314 17.6722 7.76861 17.6722 7.1243 15.931L6.07806 13.1036C5.87549 12.5561 5.44387 12.1245 4.89643 11.9219L2.06901 10.8757C0.327775 10.2314 0.327775 7.76861 2.06901 7.1243L4.89643 6.07806C5.44387 5.87549 5.87549 5.44387 6.07806 4.89643L7.1243 2.06901Z"
      fill={fill || '#E0D1FC'}
    />
  </svg>
);

export default Star;
